import React, { useState } from 'react'
import { supabase } from '../../supabase'
import Logo from '../common/Logo'

export default function LoginPage({ onLogin, onShowRegister, onShowLanding, onClientAccess, onDemoMode, emailConfirmed, paymentSuccess }) {
  const [onglet, setOnglet] = useState('connexion')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [code, setCode] = useState('')
  const [resetEmail, setResetEmail] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [resetSent, setResetSent] = useState(false)

  const handleLogin = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    const { data, error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) {
      setError('Email ou mot de passe incorrect.')
      setLoading(false)
    } else {
      onLogin(data.user)
    }
  }

  const handleClientAccess = async (e) => {
    e.preventDefault()
    const codeNormalise = code.trim().toUpperCase()
    if (codeNormalise.length !== 6) {
      setError('Le code doit contenir 6 caracteres.')
      return
    }
    setLoading(true)
    setError('')
    const { data: chantier, error: err } = await supabase
      .from('chantiers')
      .select('*')
      .eq('code', codeNormalise)
      .single()
    if (err || !chantier) {
      setError('Code invalide. Verifiez le code fourni par votre architecte.')
      setLoading(false)
      return
    }
    localStorage.setItem('cp_client_code', codeNormalise)
    setLoading(false)
    onClientAccess(chantier)
  }

  const handleResetPassword = async (e) => {
    e.preventDefault()
    if (!resetEmail.trim()) { setError('Veuillez entrer votre email.'); return }
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.resetPasswordForEmail(resetEmail.trim(), {
      redirectTo: window.location.origin + '/reset-password',
    })
    setLoading(false)
    if (error) {
      setError('Erreur : ' + error.message)
    } else {
      setResetSent(true)
    }
  }

  const switchOnglet = (o) => {
    setOnglet(o)
    setError('')
    setCode('')
    setEmail('')
    setPassword('')
    setResetSent(false)
  }

  return (
    <div className="login-page">
      <div className="login-card" style={{ width: 390 }}>
        <div className="login-logo" style={{ position: 'relative' }}>
          {onShowLanding && (
            <button
              onClick={onShowLanding}
              style={{
                position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)',
                background: 'none', border: 'none', color: '#a0aec0', fontSize: 12,
                cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4, padding: 0,
              }}
            >
              ← Accueil
            </button>
          )}
          <Logo size="md" withText={true} />
        </div>

        <div style={{ display: 'flex', background: '#f5f6fa', borderRadius: 8, padding: 4, marginBottom: 24, gap: 4 }}>
          {[
            { key: 'connexion', label: 'Connexion', icon: '🔑' },
            { key: 'client', label: 'Acces client', icon: '👁️' },
          ].map(o => (
            <button
              key={o.key}
              onClick={() => switchOnglet(o.key)}
              style={{
                flex: 1, padding: '9px 8px', border: 'none', borderRadius: 6, cursor: 'pointer',
                fontSize: 13, fontWeight: onglet === o.key ? 600 : 400,
                background: onglet === o.key ? 'white' : 'transparent',
                color: onglet === o.key ? '#1D9E75' : '#718096',
                boxShadow: onglet === o.key ? '0 1px 4px rgba(0,0,0,0.1)' : 'none',
                transition: 'all 0.15s', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
              }}
            >
              <span>{o.icon}</span> {o.label}
            </button>
          ))}
        </div>

        {paymentSuccess && (
          <div style={{ background: '#e8f7f2', border: '1.5px solid #1D9E75', borderRadius: 8, padding: '12px 16px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 10, color: '#1D9E75', fontSize: 14, fontWeight: 500 }}>
            <span style={{ fontSize: 18 }}>🎉</span>
            Paiement confirmé ! Confirmez votre email puis connectez-vous.
          </div>
        )}

        {emailConfirmed && (
          <div style={{ background: '#e8f7f2', border: '1.5px solid #1D9E75', borderRadius: 8, padding: '12px 16px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 10, color: '#1D9E75', fontSize: 14, fontWeight: 500 }}>
            <span style={{ fontSize: 18 }}>✅</span>
            Email confirmé ! Connectez-vous pour accéder à votre espace.
          </div>
        )}

        {error && <div className="error-msg">{error}</div>}

        {onglet === 'connexion' && (
          <>
            <form onSubmit={handleLogin}>
              <div className="form-group">
                <label>Adresse email</label>
                <input className="form-input" type="email" placeholder="votre@email.com"
                  value={email} onChange={e => setEmail(e.target.value)} required />
              </div>
              <div className="form-group">
                <label style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>Mot de passe</span>
                  <button
                    type="button"
                    onClick={() => switchOnglet('reset')}
                    style={{ background: 'none', border: 'none', color: '#1D9E75', fontSize: 12, cursor: 'pointer', fontWeight: 500, padding: 0 }}
                  >
                    Mot de passe oublie ?
                  </button>
                </label>
                <input className="form-input" type="password" placeholder="••••••••"
                  value={password} onChange={e => setPassword(e.target.value)} required />
              </div>
              <button type="submit" className="btn-primary" disabled={loading} style={{ marginTop: 8 }}>
                {loading ? 'Connexion...' : 'Se connecter'}
              </button>
            </form>
            <div style={{ textAlign: 'center', marginTop: 18, paddingTop: 18, borderTop: '1px solid #e2e8f0' }}>
              <span style={{ fontSize: 13, color: '#718096' }}>Pas encore de compte ? </span>
              <button onClick={onShowRegister}
                style={{ background: 'none', border: 'none', color: '#1D9E75', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
                Creer un compte
              </button>
            </div>
          </>
        )}

        {onglet === 'client' && (
          <>
            <div style={{ background: '#e8f7f2', borderRadius: 8, padding: '12px 14px', marginBottom: 20, fontSize: 13, color: '#1D9E75', lineHeight: 1.5 }}>
              <strong>Acces sans inscription</strong><br />
              Votre architecte vous a communique un code a 6 caracteres. Entrez-le ci-dessous pour consulter l avancement de votre chantier.
            </div>
            <form onSubmit={handleClientAccess}>
              <div className="form-group">
                <label>Code du chantier</label>
                <input
                  className="form-input"
                  value={code}
                  onChange={e => setCode(e.target.value.toUpperCase())}
                  placeholder="Ex: XK4T9P"
                  maxLength={6}
                  style={{ fontFamily: 'monospace', fontSize: 24, fontWeight: 700, letterSpacing: 8, textAlign: 'center', textTransform: 'uppercase' }}
                  autoComplete="off"
                  spellCheck={false}
                />
              </div>
              <button type="submit" className="btn-primary" disabled={loading || code.length === 0} style={{ marginTop: 8 }}>
                {loading ? 'Verification...' : 'Acceder a mon chantier'}
              </button>
            </form>
            <div style={{ marginTop: 18, paddingTop: 18, borderTop: '1px solid #e2e8f0', fontSize: 12, color: '#a0aec0', textAlign: 'center', lineHeight: 1.5 }}>
              Le code vous est fourni par votre architecte ou maitre d oeuvre.<br />Acces en lecture seule, aucune inscription requise.
            </div>
          </>
        )}

        {onglet === 'reset' && (
          <>
            <div style={{ marginBottom: 20 }}>
              <button
                onClick={() => switchOnglet('connexion')}
                style={{ background: 'none', border: 'none', color: '#718096', fontSize: 13, cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', gap: 4 }}
              >
                ← Retour a la connexion
              </button>
            </div>
            {resetSent ? (
              <div style={{ textAlign: 'center', padding: '24px 0' }}>
                <div style={{ fontSize: 40, marginBottom: 16 }}>📧</div>
                <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 10, color: '#1D9E75' }}>Email envoye !</div>
                <div style={{ fontSize: 14, color: '#718096', lineHeight: 1.6 }}>
                  Un lien de reinitialisation a ete envoye a <strong>{resetEmail}</strong>. Verifiez votre boite de reception (et vos spams).
                </div>
                <button
                  onClick={() => switchOnglet('connexion')}
                  style={{ marginTop: 20, background: '#1D9E75', border: 'none', borderRadius: 8, padding: '10px 24px', color: 'white', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}
                >
                  Retour a la connexion
                </button>
              </div>
            ) : (
              <form onSubmit={handleResetPassword}>
                <div style={{ marginBottom: 18, fontSize: 14, color: '#4a5568', lineHeight: 1.6 }}>
                  Entrez votre email. Nous vous enverrons un lien pour reinitialiser votre mot de passe.
                </div>
                <div className="form-group">
                  <label>Adresse email</label>
                  <input className="form-input" type="email" placeholder="votre@email.com"
                    value={resetEmail} onChange={e => setResetEmail(e.target.value)} required />
                </div>
                <button type="submit" className="btn-primary" disabled={loading} style={{ marginTop: 8 }}>
                  {loading ? 'Envoi...' : 'Envoyer le lien de reinitialisation'}
                </button>
              </form>
            )}
          </>
        )}

        <div style={{ textAlign: 'center', marginTop: 20, paddingTop: 16, borderTop: '1px solid #f0f0f0' }}>
          <button
            onClick={onDemoMode}
            style={{ background: 'none', border: 'none', color: '#a0aec0', fontSize: 13, cursor: 'pointer', padding: '4px 8px', transition: 'color 0.15s' }}
            onMouseEnter={e => e.target.style.color = '#718096'}
            onMouseLeave={e => e.target.style.color = '#a0aec0'}
          >
            Voir une demo →
          </button>
        </div>
      </div>
    </div>
  )
}
